export const PREFERRED_PRODUCTS_ID = "preferredProducts";
